import React, { useState } from 'react';
import classNames from 'classnames';

const MultipleChoiceAnswer = ({ text, isCorrect, symbol, onClick }) => {

  const [hasAnswered, setHasAnswered] = useState(false);

  const checkAnswer = (evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {
      if (!hasAnswered) {
        setHasAnswered(true);
        onClick(isCorrect);
      }
    }
  };

  return (
    <div 
      role='button'
      tabIndex={0} 
      className={classNames({
        option: true,
        selected: hasAnswered,
        correct: hasAnswered && isCorrect,
        incorrect: hasAnswered && !isCorrect,
      })} 
      onClick={(evt) => checkAnswer(evt)}
      onKeyDown={(evt) => checkAnswer(evt)}
    >
      {symbol && <span className="symbol">{symbol}</span>}
      {text && <p className="text">{text}</p>}
    </div>
  );
};

export default MultipleChoiceAnswer;
